import { render, staticRenderFns } from "./ShopList.vue?vue&type=template&id=6a24b76a&scoped=true"
import script from "./ShopList.vue?vue&type=script&lang=js"
export * from "./ShopList.vue?vue&type=script&lang=js"
import style0 from "./ShopList.vue?vue&type=style&index=0&id=6a24b76a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a24b76a",
  null
  
)

export default component.exports